import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from 'app/core/services/profile.service';
import { PaymentsBase } from 'app/core/components/web-roulette/profile/payments-base';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { MessageService } from 'primeng/api';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { ResolutionType } from 'app/shared/model/enums';

@Component({
  selector: 'app-payments-for-business',
  templateUrl: './payments-for-business.component.html',
  styleUrl: './payments-for-business.component.scss'
})
export class PaymentsForBusinessComponent extends PaymentsBase implements OnInit {
  AppResolutionType = AppResolutionType;
  ResolutionType = ResolutionType;

  constructor(
    private route: ActivatedRoute,
    profileService: ProfileService,
    messageService: MessageService,
    localizationService: LocalizationService
  ) {
    super(profileService, messageService, localizationService);
  }

  ngOnInit(): void {
    this.bussinessid = Number(this.route.parent?.snapshot.paramMap.get('id'));
    this.Init();
  }
}
